import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { SessionProvider } from '../providers/SessionProvider';
import { ServiceProvider } from '../providers/ServiceProvider';
import { LoadingProvider } from '../providers/LoadingProvider';
import { AtlasHomePage } from '../pages/atlas/AtlasHome/AtlasHome';
import { CompanySearchPage } from '../pages/atlas/CompanySearch/CompanySearch';
import { LoginProvider } from '../providers/LoginProvider';
import { CompanyDetailsPage } from '../pages/atlas/CompanyDetails/CompanyDetails';
import { ODataDetailsPage } from '../pages/atlas/ODataDetails/ODataDetails';
import { AcademyHomePage } from '../pages/academy/AcademyHome/AcademyHome';
import { AppDescribtionPage } from '../pages/AppDescribtion/AppDescribtion';
import { ChilanHomePage } from '../pages/chilan/ChilanHome/ChilanHome';
import { CurcessPage } from '../pages/academy/Curcess/Curcess';
import { SettingPage } from '../pages/Setting/Setting';
import { SettingProvider } from '../providers/SettingProvider';
import { NoteficationPage } from '../pages/Notefication/Notefication';
import { ChartsPage } from '../pages/atlas/Charts/Charts';
import { TeachingResourcesPage } from '../pages/academy/TeachingResources/TeachingResources';
import { CurcesDetailPage } from '../pages/academy/CurcesDetail/CurcesDetail';
import { NeedOpotrunityPage } from '../pages/atlas/NeedOpotrunity/NeedOpotrunity';
import { LoginPage } from '../pages/Login/Login';
import { ChilanNewsPage } from '../pages/chilan/ChilanNews/ChilanNews';
import { CapReportPage } from '../pages/atlas/CapReport/CapReport';

@NgModule({
    declarations: [
        MyApp,
        AboutPage,
        ContactPage,
        HomePage,
        TabsPage,
        AtlasHomePage,
        CompanySearchPage,
        CompanyDetailsPage,
        ODataDetailsPage,
        AcademyHomePage,
        AppDescribtionPage,
        ChilanHomePage,
        CurcessPage,
        SettingPage,
        NoteficationPage,
        ChartsPage,
        TeachingResourcesPage,
        CurcesDetailPage,
        NeedOpotrunityPage,
        LoginPage,
        ChilanNewsPage,
        CapReportPage
    ],
    imports: [
        IonicModule.forRoot(MyApp, {
            platforms: {
                ios: {
                    backButtonText: ''
                }
            }
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        AboutPage,
        ContactPage,
        HomePage,
        TabsPage,
        AtlasHomePage,
        CompanySearchPage,
        CompanyDetailsPage,
        ODataDetailsPage,
        AcademyHomePage,
        AppDescribtionPage,
        ChilanHomePage,
        CurcessPage,
        SettingPage,
        NoteficationPage,
        ChartsPage,
        TeachingResourcesPage,
        CurcesDetailPage,
        NeedOpotrunityPage,
        LoginPage,
        ChilanNewsPage,
        CapReportPage
    ],
    providers: [
        SessionProvider,
        ServiceProvider,
        LoadingProvider,
        LoginProvider,
        SettingProvider,
        { provide: ErrorHandler, useClass: IonicErrorHandler }]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts